var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"day-plan-slot-pause"},[_c('div',{staticClass:"day-plan-slot-pause-title"},[_vm._v(" "+_vm._s(_vm.duration)+" Min ")]),_c('div',{staticClass:"day-plan-slot-pause-content"},[_vm._v(" "+_vm._s(_vm.dayPlanSlot.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }